// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__xprJP","step":"style_step__1Sdut"};